import React, { useState, lazy } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Check, ChevronDown } from 'lucide-react';
const volumes = [{
  num: 1,
  title: 'FONDAMENTI TECNICI DEL BALLET™',
  subtitle: 'La base che nessuno ti insegna',
  image: 'https://images.unsplash.com/photo-1518611012118-696072aa579a?auto=format&fit=crop&w=1200&h=400&q=80',
  points: ['Comprendi la pedagogia dietro ogni movimento.', 'Impara a correggere postura, allineamento e posizioni in modo preciso senza demotivare le allieve.', 'Le 5 posizioni fondamentali spiegate con progressione pedagogica.', 'Biomeccanica del movimento classico spiegata in modo semplice.', 'Come correggere gli errori tecnici più frequenti senza scoraggiare.']
}, {
  num: 2,
  title: 'LIBRERIA DI ESERCIZI ALLA SBARRA™',
  subtitle: 'Oltre 60 esercizi pronti per qualsiasi livello',
  image: 'https://images.unsplash.com/photo-1547153760-18fc86324498?auto=format&fit=crop&w=1200&h=400&q=80',
  points: ['60+ esercizi alla sbarra classificati per livello: principiante, intermedio e avanzato.', 'Struttura completa di ogni esercizio con descrizione, correzioni, progressione e musica consigliata.', 'Combinazioni di sbarra pronte da usare senza modificare nulla.', 'Come costruire una sbarra completa in meno di 10 minuti.', 'Adattamenti per spazi ridotti o senza sbarra fisica.']
}, {
  num: 3,
  title: 'SISTEMA DI COSTRUZIONE DELLE LEZIONI™',
  subtitle: 'Crea una lezione professionale in 10 minuti o meno',
  image: 'https://images.unsplash.com/photo-1535525153412-5a42439a210d?auto=format&fit=crop&w=1200&h=400&q=80',
  points: ['Framework di lezione completa: riscaldamento → sbarra → centro → allegro → reverence.', '12 modelli di lezione pronti da usare per livello, durata e obiettivo.', 'Come strutturare lezioni da 45, 60 e 90 minuti.', 'Sistema di variazione perché le allieve non si annoino mai.', 'Come gestire gruppi misti con livelli diversi.']
}, {
  num: 4,
  title: 'COREOGRAFIE E SEQUENZE PRONTE™',
  subtitle: 'Oltre 40 sequenze coreografiche pronte da insegnare',
  image: 'https://images.unsplash.com/photo-1504609773096-104ff2c73ba4?auto=format&fit=crop&w=1200&h=400&q=80',
  points: ['40+ sequenze di centro e terra organizzate per livello.', 'Piccolo allegro, grand allegro e adagio già strutturati e pronti.', 'Variazioni coreografiche per saggi di fine anno e spettacoli.', 'Sequenze espressive per lezioni di adulte e ballet fitness.', 'Come presentare una sequenza nuova senza che le allieve si perdano.']
}, {
  num: 5,
  title: 'PROGRAMMI DI PROGRESSIONE 4, 8 E 12 SETTIMANE™',
  subtitle: 'La mappa completa da zero a risultati visibili',
  image: 'https://images.unsplash.com/photo-1551105378-78e609e1d468?auto=format&fit=crop&w=1200&h=400&q=80',
  points: ['3 programmi completi pronti: 4 settimane, 8 settimane e 12 settimane.', 'Periodizzazione pedagogica: come aumentare la difficoltà senza saturare.', 'Programmi separati per principianti adulte, bambine e livello intermedio.', 'Sistema di valutazione integrato in ogni programma.', 'Indicatori di progresso settimana per settimana.']
}, {
  num: 6,
  title: 'MUSICA E ATMOSFERA PERFETTA™',
  subtitle: 'Il sistema completo per scegliere la musica giusta in ogni momento della lezione',
  image: 'https://images.unsplash.com/photo-1465847899084-d164df4dedc6?auto=format&fit=crop&w=1200&h=400&q=80',
  points: ['Come scegliere il tempo esatto per ogni esercizio di sbarra e centro.', 'Elenco di opere classiche organizzate per BPM e uso pedagogico.', 'Musica per riscaldamento, sbarra, centro, allegro e reverence.', "Come creare un'atmosfera professionale che faccia venir voglia di tornare alle allieve.", 'Errori musicali che distruggono il clima della lezione.']
}, {
  num: 7,
  title: 'COACHING, VALUTAZIONE E FIDELIZZAZIONE™',
  subtitle: 'Gli strumenti per trattenere le allieve e costruire una scuola di successo',
  image: 'https://images.unsplash.com/photo-1508700115892-45ecd05ae2ad?auto=format&fit=crop&w=1200&h=400&q=80',
  points: ['Sistema di valutazione tecnica individuale per ogni allieva.', 'Schede di monitoraggio e progressi pronte da stampare e da usare.', 'Come dare feedback correttivo senza demotivare né ferire.', 'Sistema di fidelizzazione per fare in modo che le allieve non abbandonino mai.', 'Protocollo della prima lezione per trasformare allieve nuove in allieve permanenti.']
}];
export function Volumes() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const toggleAccordion = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section className="py-16 md:py-24 bg-ballet-50" data-id="element-244">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-245">
        <div className="text-center mb-12 md:mb-16" data-id="element-246">
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-charcoal mb-4 md:mb-6" data-id="element-247">
            I 7 VOLUMI
          </h2>
          <p className="text-lg md:text-xl text-gray-600" data-id="element-248">
            La tua guida completa per dominare l'insegnamento del ballet.
          </p>
        </div>

        <div className="space-y-6 md:space-y-8" data-id="element-249">
          {volumes.map((vol, index) => {
          const isOpen = openIndex === index;
          return <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-50px'
          }} transition={{
            duration: 0.4
          }} className="bg-white rounded-2xl md:rounded-3xl overflow-hidden shadow-sm border border-ballet-100" data-id="element-250">
                {/* 3:1 representative banner - Clickable Accordion Header */}
                <button onClick={() => toggleAccordion(index)} aria-expanded={isOpen} className="w-full relative aspect-[2.5/1] md:aspect-[3/1] overflow-hidden group text-left block" data-id="element-251">
                  <img src={vol.image} alt={vol.title} className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" loading="lazy" data-id="element-252" />
                  <div className="absolute inset-0 bg-gradient-to-r from-charcoal/90 via-charcoal/60 to-charcoal/30 transition-opacity duration-300 group-hover:opacity-90" data-id="element-253" />

                  <div className="relative h-full flex flex-col justify-center px-5 md:px-10" data-id="element-254">
                    <span className="inline-flex items-center self-start bg-ballet-500 text-white text-[10px] md:text-xs font-bold tracking-widest px-2.5 py-1 md:px-3 rounded-full mb-2 md:mb-3" data-id="element-255">
                      VOLUME {vol.num}
                    </span>
                    <h3 className="text-lg md:text-3xl font-serif font-bold text-white leading-tight max-w-[85%] md:max-w-lg" data-id="element-256">
                      {vol.title}
                    </h3>
                    <p className="text-ballet-200 italic mt-1 md:mt-2 text-xs md:text-base max-w-[85%] md:max-w-lg line-clamp-1 md:line-clamp-none" data-id="element-257">
                      "{vol.subtitle}"
                    </p>
                  </div>

                  <div className="absolute right-4 md:right-8 top-1/2 -translate-y-1/2 w-8 h-8 md:w-10 md:h-10 rounded-full bg-white/10 backdrop-blur-sm flex items-center justify-center border border-white/20 transition-colors group-hover:bg-white/20" data-id="element-258">
                    <ChevronDown className={`w-5 h-5 md:w-6 md:h-6 text-white transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`} data-id="element-259" />
                  </div>
                </button>

                {/* description list - Accordion Content */}
                <AnimatePresence initial={false} data-id="element-260">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3,
                ease: 'easeInOut'
              }} data-id="element-261">
                      <div className="p-5 md:p-8 border-t border-ballet-50" data-id="element-262">
                        <ul className="space-y-3 md:space-y-4" data-id="element-263">
                          {vol.points.map((point, idx) => <li key={idx} className="flex items-start gap-3" data-id="element-264">
                              <span className="mt-0.5 flex-shrink-0 w-4 h-4 md:w-5 md:h-5 rounded-full bg-ballet-100 flex items-center justify-center" data-id="element-265">
                                <Check className="w-2.5 h-2.5 md:w-3.5 md:h-3.5 text-ballet-600" data-id="element-266" />
                              </span>
                              <span className="text-sm md:text-base text-gray-700 leading-relaxed" data-id="element-267">
                                {point}
                              </span>
                            </li>)}
                        </ul>
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}